import { combineReducers } from 'redux';
import UsuarioReducer from './usuarioreducer';
import CartReducer from './cartreducer';
import ItemReducer from './itemreducer';
import EntregaReducer from './entregareducer';
import Identify from './identify';

export default combineReducers({
    usuario: UsuarioReducer,
    cart: CartReducer,
    item: ItemReducer,
    entrega: EntregaReducer,
    identificador: Identify
});
